export default {
  reviewsInRcPay: "RC PAY’dagi sharhlar",
  hideStatus:
    "Sizning savdo nuqtangiz sahifasidan rcpay.ru saytida yashirish kerakmi?",
  showStatus:
    "Sizning savdo nuqtangiz sahifasida rcpay.ru saytida ko‘rsatish kerakmi?",
  review: "Sharh",
  ratings: "Baholar",

  status: {
    all: "Barchasi",
    publish: "E’lon qilingan",
    hidden: "Yashirilgan",
  },

  hidden: "Yashirilgan",
  published: "E’lon qilingan",

  zeroHide: "Yashirildi",
  zeroPublished: "E’lon qilindi",

  aboutChapter: {
    title: "Bo‘lim haqida ma’lumot",
    descriptions: [
      "«Sharhlar» bo‘limida sizning muassasalaringizga tashrif buyurgan va RC PAY orqali fikr bildirgan barcha mijozlarning sharhlari joylashgan.",
      "Matnsiz va 4 yoki 5 yulduzli baholarga ega sharhlar avtomatik tarzda e’lon qilinadi. Boshqa barcha sharhlar sukut bo‘yicha yashirilgan bo‘ladi va RC PAY’da ko‘rsatilmaydi, lekin umumiy reyting hisobiga kiritiladi. Ularni ko‘rinadigan qilish uchun, ularni qo‘lda e’lon qilish kerak.",
    ],
    howPublishOrHide: {
      title: "RC PAY’da sharhlarni qanday e’lon qilish yoki yashirish mumkin?",
      list: [
        "Bir yoki bir nechta sharhni tanlang.",
        "Pastki harakat panelida «E’lon qilish» yoki «Yashirish» tugmasini bosing.",
      ],
    },
    howFilter: {
      title: "Sharhlarni qanday filtrlash yoki tartiblash mumkin?",
      description:
        "Sharhlar bilan qulay ishlash uchun filtrlar va tartiblash imkoniyati mavjud:",
      list: [
        "Savdo nuqtalari bo‘yicha filtr. Sukut bo‘yicha barcha muassasalarga tegishli sharhlar ko‘rsatiladi. Agar «Savdo nuqtasi» filtrini tanlasangiz, faqat shu joyga tegishli sharhlar chiqadi.",
        "Sana bo‘yicha filtr. Sana tanlanganda, shu davrga tegishli sharhlar ko‘rsatiladi.",
        "Sharhlarni yangiligi bo‘yicha (avval yangi/eski) yoki baho bo‘yicha (manfiy/ijobiy) tartiblash mumkin.",
      ],
    },
  },

  noReviewsYet: "Hozircha sharhlar yo‘q",
  createShopToGetReviews:
    "RC PAY mijozlaridan sharh olish uchun savdo nuqtasini yarating",
  appearAfterClientSetRating:
    "Bu yerda sizning muassasangizga tashrif buyurgan mijoz RC PAY’da baho bergandan so‘ng paydo bo‘ladi",
  noPublishedReviews: "E’lon qilingan sharhlar yo‘q",
  allReviewsHiddenInRc: "Barcha sharhlar RC PAY’da yashirilgan",
  allReviews: "Barcha sharhlar",
  allRatings: "Barcha baholar",
  noHiddenReviews: "Yashirilgan sharhlar yo‘q",
  allReviewsShownInRc: "Barcha sharhlar RC PAY’da e’lon qilingan",

  sort: {
    firstNew: "Avval yangilar",
    firstOld: "Avval eskilar",
    goodFirst: "Bahoga ko‘ra kamayish tartibida",
    badFirst: "Bahoga ko‘ra o‘sish tartibida",
  },

  removeSelection: "Tanlovni olib tashlash",
  chooseAllReviews: "Barcha sharhlarni tanlash",
  overallAssessment: {
    title: "Umumiy baho",
    hint: [
      "Filtrlar o‘rnatilganda, umumiy baho va sharhlar soni qayta hisoblanadi.",
      "Umumiy baho barcha sharhlarni, shu jumladan RC PAY’da yashirilganlarini ham hisobga oladi.",
    ],
  },
  totalAmountReviews: "Jami sharhlar soni",
  amountPublishReviews: "E’lon qilingan sharhlar soni",
  amountHiddenReviews: "Yashirilgan sharhlar soni",
  userPhoto: "Foydalanuvchi fotosurati",
  showInRcPay: "RC PAY’da ko‘rsatish",
  hideInRcPay: "RC PAY’da yashirish",
  hiddenReviewsNotVisibleToRcPayUsers:
    "Yashirilgan sharhlar RC PAY foydalanuvchilariga ko‘rinmaydi, ammo ular sizning muassasangizning umumiy reytingiga hisobga olinadi. Ularni ko‘rinadigan qilish uchun bir yoki bir nechta sharhni tanlab, pastki panelda paydo bo‘ladigan «RC PAY’da e’lon qilish» tugmasini bosing.",
};
